const btns = document.querySelectorAll(".btn");
const slideRow = document.getElementById("slide-row");
const slides = document.querySelectorAll(".slide-col");

let currentIndex = 0;

function updateSlide() {
  const slideWidth = slides[0].offsetWidth + 20; // Include column gap
  const translateValue = currentIndex * -slideWidth; // Calculate translation
  slideRow.style.transform = `translateX(${translateValue}px)`;

  btns.forEach((btn, index) => {
    btn.classList.toggle("active", index === currentIndex);
  });
}

btns.forEach((btn, index) => {
  btn.addEventListener("click", () => {
    currentIndex = index;
    updateSlide();
  });
});

window.addEventListener("resize", () => {
  updateSlide(); // Adjust slider on window resize
});

// Initialize slide position
updateSlide();
